module.exports = __webpack_public_path__ + "static/scale-model-of-cowabunga's-in-manchester-new-hampshire-cd8810faaa2ae9aa186ab22321c3d4b8.png";